import * as types from '../actions/action-types';

import { timeFilter, coachType, amenFilter } from '../common/filters';

const initialState = {
  searchParams: '',
  data: [], // search API results ---- as is from API
  buses: [], // Bus data ---- to be used for sorting & filtering ---- can be reset based on data mentioned above
  // Static data to be updated once
  staticData: { coach: ['AC', 'Non AC', 'Seater', 'Sleeper', 'Volvo', 'Non Volvo'] },
  // Filtered data to be updated based on user input
  time: [],
  amenities: [],
  coach: [],
  stChrtStatus: {},
  stChrtOthrDtls: {},
  order: [],
  currency: window.location.hostname == 'busdemo.travels.com.mm' ? 'K' : '₹'
};

const searchReducer = function(state = initialState, action) {
  let currState = state;
  let buses;
  let stChrtStatus = state.stChrtStatus;
  let stChrtOthrDtls = state.stChrtOthrDtls;
  let order = state.order;
  switch(action.type) {
    case types.GET_SEARCH_PARAMS:
      return Object.assign({}, state, {
        searchParams: action.data
      });
    case types.GET_SEARCH_RES:
      const allAmen = action.data ? getAmen(action.data) : false;
      const disBuses = action.data ? getDiscount(action.data) : false;
      const filterBuses = disBuses ? disBuses.filter(el => el.AvailableSeats > 0) : disBuses;
      return Object.assign({}, state, {
        data: disBuses,
        buses: filterBuses,
        allAmen
      });
    case types.UPDATE_BUS:
      return Object.assign({}, state, {
        buses: action.data
      });
    // Time Filter
    case types.UPDATE_FILTER_TIME:
      currState.time = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { 
        time: action.data, 
        buses
      });
    // Coach filter
    case types.UPDATE_FILTER_COACH:
      currState.coach = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { coach: action.data, buses});
    // Amen filter
    case types.UPDATE_FILTER_AMEN:
      currState.amenities = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { amenities: action.data, buses });
    // Reset filter
    case types.UPDATE_FILTER_RESET:
      currState.time = [];
      currState.amenities = [];
      currState.coach = [];
      buses = parseFilter(currState);
      return Object.assign({}, state, {
        time: [],
        amenities: [],
        coach: [],
        buses
      });
    case types.UPDATE_SEAT_CHART:
      stChrtStatus[action.rsid] = action.data;
      return Object.assign({}, state, {
        stChrtStatus 
      });
    case types.UPDATE_SEAT_CHART_DET:
      stChrtOthrDtls[action.rsid] = action.data;
      return Object.assign({}, state, {
        stChrtOthrDtls 
      });
    case types.UPDATE_CHECKOUT_DET:
      return Object.assign({}, state, {
        order: action.data 
      });
    case types.UPDATE_USER_NAME:
      order[action.param].seatDetails[action.seat].name = action.data;
      return Object.assign({}, state, {
        order
      });
    case types.UPDATE_USER_AGE:
      order[action.param].seatDetails[action.seat].age = action.data;
      return Object.assign({}, state, {
        order
      });
    case types.UPDATE_USER_GENDER:
      order[action.param].seatDetails[action.seat].gender = action.data;
      return Object.assign({}, state, {
        order
      });
    default:
      return state;
  }
}

// const searchParseStaticData = (data) => {
//   const buses = data.Buses;
//   const amenArr = data.AllAmenities;
//   const coach = ['Seater / Semi-Sleeper', 'Sleeper', 'AC', 'Non AC', 'Volvo / Mercedes', 'Non Volvo'];
//   let minFare, maxFare, minDepHr, maxDepHr, pickups = [], dropoffs = [], operators = [], amenities = [];
//   buses.forEach((el, index) => {
//     if (index === 0) {
//         minFare = el.BusStatus.DiscFares[0];
//         maxFare = el.BusStatus.DiscFares[0];
//         minDepHr = new Date(el.DeptTime).getHours();
//         maxDepHr = new Date(el.DeptTime).getHours();
//     }
//     if (index > 0) {
//         minFare = el.BusStatus.DiscFares[0] < minFare ? el.BusStatus.DiscFares[0] : minFare;
//         maxFare = el.BusStatus.DiscFares[0] > maxFare ? el.BusStatus.DiscFares[0] : maxFare;
//         minDepHr = new Date(el.DeptTime).getHours() < minDepHr ? new Date(el.DeptTime).getHours() : minDepHr;
//         maxDepHr = new Date(el.DeptTime).getHours() > maxDepHr ? new Date(el.DeptTime).getHours() : maxDepHr;
//     }
//     el.Pickups.forEach(pick => pickups.indexOf(pick.PickupName) === -1 ? pickups.push(pick.PickupName) : '');
//     el.Dropoffs.forEach(drop => dropoffs.indexOf(drop.DropoffName) === -1 ? dropoffs.push(drop.DropoffName) : '');
//     el.Amenities.forEach(amen => amenities.indexOf(amenArr[amen]) === -1 ? amenities.push(amenArr[amen]) : '');
//     if (operators.indexOf(el.CompanyName) === -1) {operators.push(el.CompanyName);}
//   });

//   return {
//     minPrice: minFare,
//     maxPrice: maxFare,
//     minDepHr: minDepHr,
//     maxDepHr: maxDepHr,
//     operators: operators,
//     amenities: amenities,
//     pickups: pickups,
//     dropoffs: dropoffs,
//     coach: coach
//   };
// }



const parseFilter = (st) => {
  const loop = st.data;
    let buses = [];
    for (let i = 0; i < loop.length; i++) {
      const val = 
      timeFilter(loop[i], st.time) &&
      coachType(loop[i], st.coach, st.staticData.coach) &&
      amenFilter(loop[i], st.amenities, st.allAmen);
        if (val) {
        buses.push(loop[i]);
      }
    }
    return buses;
}

const getAmen = (val) => {
  let amen = [];
  val.forEach(el => {
    const amn = el.AmenitiesType.split(',');
    if (amn.length > 0) {
      amn.forEach(vl => {
        if (amen.indexOf(vl) === -1 && vl !== '') {
          amen.push(vl);
        }
      });
    }
  });
  return amen;
}

const getDiscount = (val) => {
  val.forEach(el => {
    if (el.DiscountAmt > 0) {
      el['DiscFare'] = el.Fare - el.DiscountAmt;
    } else if (el.DiscountPer > 0) {
      el['DiscFare'] = Math.floor(el.Fare - (el.Fare * el.DiscountPer / 100));
    } else {
      el['DiscFare'] = el.Fare;
    }
  });
  return val;
}

export default searchReducer;
